<header class="sticky-top bg-white border-bottom shadow-sm header-wrapper">
  <div class="container d-flex align-items-center justify-content-between py-3">
    <!-- Logo & Title -->
    <div class="d-flex align-items-center gap-3">
      <div class="d-flex align-items-center justify-content-center bg-primary text-white rounded logo-header">
        <span class="fw-bold fs-5">I</span>
      </div>
      <div>
        <h1 class="h5 fw-bold text-primary mb-0">IIMA</h1>
        <p class="small text-muted mb-0">Indian Navy</p>
      </div>
    </div>

    <!-- Navigation -->
    <nav class="d-none d-md-flex align-items-center gap-3">
      <button 
        (click)="navigateToLogin()"
        class="btn btn-link text-dark px-3 py-2 rounded transition explore-iima">
        Explore IIMA
      </button>
      <button 
        (click)="scrollToSection('schemes')"
        class="btn btn-outline-primary px-3 py-2 rounded">
        View Schemes
      </button>
    </nav>
  </div>
</header>

<section class="position-relative vh-100 d-flex align-items-center justify-content-center overflow-hidden pt-5">
  <!-- Background Video -->
  <img
    src="assets/images/iima-landingpage.png"
    class="hero-image position-absolute top-0 start-0 w-100 h-100"
    alt="IIMA Landing Page"
  />


  <!-- Overlay -->
  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25"></div>

  <!-- Hero Content -->
  <!-- <div class="position-relative z-1 text-center text-white px-3 px-md-5 hero-cont-mw">
    <div class="fade-in">
      <h1 class="display-4 fw-bold mb-4 lh-tight">
        Innovation & Indigenisation<br />
        <span class="text-warning">Management Application</span>
      </h1>
      <p class="fs-5 fs-md-4 mb-4 text-white-75 mx-auto digitize-mw">
        Digitizing the complete lifecycle of Innovation & Indigenisation in the Indian Navy
      </p>
      <div class="d-flex flex-column flex-sm-row gap-3 justify-content-center">
        <button 
          (click)="navigateToLogin()"
          class="btn btn-warning text-dark px-4 py-2 fw-semibold shadow">
          Explore IIMA
        </button>
        <button 
          (click)="scrollToSection('schemes')"
          class="btn btn-outline-light px-4 py-2 fw-semibold">
          View Schemes
        </button>
      </div>
    </div>
  </div> -->
</section>

<section id="naval-process" class="py-5 bg-light">
  <div class="container px-3 px-md-5">

    <!-- Heading -->
    <div class="text-center mb-5 fade-up">
      <h2 class="h2 fw-bold text-dark mb-3">From Concept to Combat</h2>
      <p class="fs-5 text-muted mx-auto naval-process-mw">
        Follow the complete journey of naval innovation through our comprehensive process timeline
      </p>
    </div>

    <!-- Timeline Steps -->
    <div class="d-flex justify-content-between align-items-start flex-wrap naval-timeline position-relative">
      <div *ngFor="let step of processSteps; let i = index" class="timeline-block text-center position-relative mb-5">
        
        <!-- Circle Icon -->
       <div class="timeline-bubble d-flex align-items-center justify-content-center mb-3"
     [ngClass]="{
       'bubble-past': i < activeStep,
       'bubble-current': i === activeStep,
       'bubble-upcoming': i > activeStep
     }">
  <span class="fs-4">{{ step.icon }}</span>
</div>


        <!-- Title -->
        <h5 class="timeline-title fw-bold mb-1">{{ step.title }}</h5>

        <!-- Description -->
        <p class="timeline-desc text-muted mb-0">{{ step.description }}</p>

        <!-- Connector -->
        <div *ngIf="i < processSteps.length - 1" class="timeline-line"
             [ngClass]="{
               'line-past': i < activeStep,
               'line-upcoming': i >= activeStep
             }">
        </div>
      </div>
    </div>

  </div>
</section>

<section class="py-5 bg-white">
  <div class="container px-3 px-md-5">
    
    <!-- Heading -->
    <div class="text-center mb-5 fade-in">
      <h2 class="h2 fw-bold text-primary mb-3">
        Key Benefits
      </h2>
      <p class="fs-5 text-muted mx-auto streamline-mw">
        Streamlined processes, enhanced visibility, and accelerated innovation cycles
      </p>
    </div>

    <!-- Benefits Grid -->
    <div class="row g-4">
      <div 
        *ngFor="let benefit of benefits; let i = index"
        class="col-12 col-md-6 col-lg-3">
        
        <div class="card benefit-card h-100 text-center p-4">
          <div class="benefit-icon mb-3">{{ benefit.icon }}</div>
          <h3 class="fw-semibold text-primary mb-2">{{ benefit.title }}</h3>
          <p class="small text-muted">{{ benefit.description }}</p>
        </div>

      </div>
    </div>
  </div>
</section>


<section id="schemes" class="py-5 bg-light">
  <div class="container px-3 px-md-5">
    
    <!-- Heading -->
    <div class="text-center mb-5 fade-in">
      <h2 class="h2 fw-bold text-primary mb-3">
        Schemes Covered
      </h2>
      <p class="fs-5 text-muted mx-auto streamline-mw">
        Comprehensive coverage aligned to INICOP 2024-2026 guidelines
      </p>
    </div>

    <!-- Scheme Pills -->
    <div class="d-flex flex-wrap justify-content-center gap-2 mb-4">
      <div 
        *ngFor="let scheme of schemes; let i = index"
        class="scheme-pill"
        (click)="openSchemeDialog(scheme)">
        {{ scheme.name }}
      </div>
    </div>

  </div>
</section>


<!-- How IIMA Works -->
<section class="py-5 bg-white">
  <div class="container px-3 px-md-5">

    <!-- Heading -->
    <div class="text-center mb-5 fade-in">
      <h2 class="h2 fw-bold text-primary mb-3">How IIMA Works</h2>
      <p class="fs-5 text-muted mx-auto streamline-mw">
        Three key stakeholder groups working together for naval innovation
      </p>
    </div>

    <!-- Stakeholder Cards -->
    <div class="row g-4">
      <div *ngFor="let group of stakeholderGroups; let i = index" class="col-12 col-md-4">
        <div class="card stakeholder-card h-100 text-center p-4">
          
          <!-- Icon with gradient background -->
          <div class="icon-circle mb-4">
            <span class="icon-emoji">{{ group.icon }}</span>
          </div>
          
          <!-- Title -->
          <h3 class="h5 fw-semibold text-primary mb-3">{{ group.title }}</h3>
          
          <!-- Points -->
          <div class="points-list">
            <div *ngFor="let point of group.points" class="d-flex align-items-start mb-2">
              <div class="bullet me-2 mt-1"></div>
              <span class="small text-muted text-start">{{ point }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>



<!-- Security & Compliance -->
<!-- <section class="py-4 bg-primary">
  <div class="container px-3 px-md-5">
    <div class="text-center fade-in">
      <h3 class="h4 fw-bold text-white mb-4">
        Security & Compliance First
      </h3>
      <div class="d-flex flex-wrap justify-content-center align-items-center gap-3 text-white-50">
        <span class="d-flex align-items-center gap-2">
          <span>🔐</span><span>RBAC</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>📊</span><span>Auditability</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>🛡️</span><span>Least Privilege</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>🔒</span><span>Data Integrity</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>🔑</span><span>SSO Ready</span>
        </span>
      </div>
    </div>
  </div>
</section> -->


<section class="py-5 text-center text-white bg--blue">
     <div class="container px-3 px-md-5 mb-5">
    <div class="text-center fade-in">
      <h3 class="h4 fw-bold text-white mb-4">
        Security & Compliance First
      </h3>
      <div class="d-flex flex-wrap justify-content-center align-items-center gap-3 text-white-50">
        <span class="d-flex align-items-center gap-2">
          <span>🔐</span><span>RBAC</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>📊</span><span>Auditability</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>🛡️</span><span>Least Privilege</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>🔒</span><span>Data Integrity</span>
        </span>
        <div class="vr opacity-50"></div>
        <span class="d-flex align-items-center gap-2">
          <span>🔑</span><span>SSO Ready</span>
        </span>
      </div>
    </div>
  </div>
  <div class="container px-3 px-md-5">
    <div class="fade-in">
      <h2 class="h2 fw-bold mb-3">
        From Concept to Combat
      </h2>
      <p class="fs-4 text-white-75 mb-4">
        Powered by Indigenisation
      </p>
      <div class="d-flex flex-column flex-sm-row gap-3 justify-content-center">
        <button 
          class="btn btn-warning text-dark fw-semibold px-4 py-2 shadow">
          Request a Walkthrough
        </button>
        <button 
          (click)="scrollToSection('process')"
          class="btn btn-outline-light fw-semibold px-4 py-2">
          View Process
        </button>
      </div>
    </div>
  </div>
</section>



<!-- <div class="bg-animation"></div> -->

<!-- Cyberpunk Navigation -->
<!-- <nav class="navbar">
    <div class="d-flex justify-content-between nav-head-content ">
        <div class="d-flex gap-3">
            <img src="../../assets/images/iimalogo--removebg-preview[1] (2).png" class="logo-img">
            <div class="logo">IIMA</div>
        </div>
        <div>
            <a  class="login-btn"  (click)="navigateToLogin()">Access Portal</a> 
        </div>
    </div>
</nav> -->

<!-- Futuristic Hero Section -->
<!-- <section class="hero" id="home">
    <div class="hero-bg-elements">
        <div class="floating-element"></div>
        <div class="floating-element"></div>
        <div class="floating-element"></div>
    </div>
    <div class="hero-content">
        <div class="hero-title">Innovation & Indigenisation<br>Management Application (IIMA)</div>
        <p class="hero-subtitle">
            A unified digital platform to streamline, automate, and monitor initiatives under INICOP 2024-2026.
            Designed for transparency, accountability, and operational excellence across the Indian Navy.
        </p>
        <div class="hero-actions">
            <button class="primary-btn" (click)="navigateToLogin()">Access IIMA</button>
        </div>
    </div>
</section> -->


<!-- Neon Features Section -->
<!-- <section class="features" id="features">
    <div class="features-container">
        <div class="section-header reveal">
            <div class="section-badge">Key Features</div>
            <h2 class="section-title">Core Capabilities</h2>
            <p class="section-subtitle">
                Comprehensive modules supporting proposal lifecycle management, evaluations, reporting,
                and Navy-standard workflows.
            </p>
        </div>
        <div class="features-grid">
            <div class="feature-card reveal">
                <div class="feature-icon"><i class="fas fa-file-alt"></i></div>
                <h3 class="feature-title">Proposal Lifecycle</h3>
                <p class="feature-description">
                    Uniform intake, version control, automated IDs, routing, and
                    complete traceability for all proposals across supported schemes.
                </p>
            </div>
            <div class="feature-card reveal">
                <div class="feature-icon"><i class="fas fa-cogs"></i></div>
                <h3 class="feature-title">Evaluation Engine</h3>
                <p class="feature-description">
                    Auto-scoring using configurable criteria with concurrent vetting,
                    skip logic, and role-based access for Initiator, Recommender, and Approver.
                </p>
            </div>
            <div class="feature-card reveal">
                <div class="feature-icon"><i class="fas fa-database"></i></div>
                <h3 class="feature-title">Global Masters</h3>
                <p class="feature-description">
                    Centralized management of Schemes, Vendors, Committees, Equipment, and Funds
                    with integrated audit trails and real-time validations.
                </p>
            </div>
            <div class="feature-card reveal">
                <div class="feature-icon"><i class="fas fa-chart-line"></i></div>
                <h3 class="feature-title">Dashboards & Reports</h3>
                <p class="feature-description">
                    Interactive dashboards with cascading filters, live operational insights,
                    and exportable reports in PDF/Excel formats.
                </p>
            </div>
        </div>
    </div>
</section> -->


<!-- Holographic Mission Section -->
<!-- <section class="mission" id="mission">
    <div class="mission-container">
        <h2 class="mission-title reveal">Strategic Vision</h2>
        <div class="mission-content reveal">
            <p class="mission-text">
                To strengthen innovation and indigenisation in the Indian Navy by creating a
                digital-first ecosystem that manages the complete lifecycle of projects and
                proposals while ensuring transparency, accountability, and faster decision-making.
            </p>
            <div class="mission-stats">
                <div class="mission-stat reveal">
                    <span class="stat-number">4</span>
                    <span class="stat-label">Schemes Supported</span>
                </div>
                <div class="mission-stat reveal">
                    <span class="stat-number">24/7</span>
                    <span class="stat-label">Operational Access</span>
                </div>
                <div class="mission-stat reveal">
                    <span class="stat-number">100%</span>
                    <span class="stat-label">Transparency & Traceability</span>
                </div>
            </div>
        </div>
    </div>
</section> -->


<!-- Fleet Showcase Section -->
<!-- <section class="fleet" id="fleet">
    <div class="fleet-container">
        <div class="section-header reveal">
            <div class="section-badge">Naval Assets</div>
            <h2 class="section-title">Fleet Overview</h2>
            <p class="section-subtitle">
                Advanced maritime platforms ensuring dominance across surface,
                underwater, and aerial domains
            </p>
        </div>
        <div class="fleet-grid">
            <div class="fleet-card reveal">
                <div class="fleet-icon">
                    <i class="fas fa-ship"></i>
                </div>
                <h3 class="fleet-title">INS Vikrant</h3>
                <p class="fleet-description">
                    Indigenous aircraft carrier with state-of-the-art aviation facilities,
                    advanced defense systems, and enhanced operational capabilities.
                </p>
                <div class="fleet-specs">
                    <div class="spec">
                        <span class="spec-value">45,000t</span>
                        <span class="spec-label">Displacement</span>
                    </div>
                    <div class="spec">
                        <span class="spec-value">30+</span>
                        <span class="spec-label">Aircraft</span>
                    </div>
                    <div class="spec">
                        <span class="spec-value">2022</span>
                        <span class="spec-label">Commissioned</span>
                    </div>
                </div>
            </div>
            <div class="fleet-card reveal">
                <div class="fleet-icon">
                    <i class="fas fa-submarine"></i>
                </div>
                <h3 class="fleet-title">INS Arihant</h3>
                <p class="fleet-description">
                    Nuclear-powered ballistic missile submarine with strategic
                    deterrence capabilities and advanced stealth technology.
                </p>
                <div class="fleet-specs">
                    <div class="spec">
                        <span class="spec-value">6,000t</span>
                        <span class="spec-label">Displacement</span>
                    </div>
                    <div class="spec">
                        <span class="spec-value">750m</span>
                        <span class="spec-label">Depth</span>
                    </div>
                    <div class="spec">
                        <span class="spec-value">2016</span>
                        <span class="spec-label">Commissioned</span>
                    </div>
                </div>
            </div>
            <div class="fleet-card reveal">
                <div class="fleet-icon">
                    <i class="fas fa-fighter-jet"></i>
                </div>
                <h3 class="fleet-title">Boeing P-8I</h3>
                <p class="fleet-description">
                    Long-range maritime reconnaissance aircraft with anti-submarine
                    and anti-surface warfare capabilities.
                </p>
                <div class="fleet-specs">
                    <div class="spec">
                        <span class="spec-value">12+</span>
                        <span class="spec-label">In Service</span>
                    </div>
                    <div class="spec">
                        <span class="spec-value">2,200km</span>
                        <span class="spec-label">Range</span>
                    </div>
                    <div class="spec">
                        <span class="spec-value">2013</span>
                        <span class="spec-label">Commissioned</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- News Section -->
<!-- <section class="news" id="news">
    <div class="news-container">
        <div class="section-header reveal">
            <div class="section-badge">System Updates</div>
            <h2 class="section-title">Recent Enhancements</h2>
            <p class="section-subtitle">
                Continuous upgrades to deliver efficiency, security, and Navy-standard usability
            </p>
        </div>
        <div class="news-grid">
            <div class="news-card reveal">
                <div class="news-date">2025</div>
                <h3 class="news-title">API-First Backend</h3>
                <p class="news-excerpt">
                    PostgreSQL 16 with ship-wise table partitioning and an API-first architecture
                    for speed, scalability, and seamless integration.
                </p>
            </div>
            <div class="news-card reveal">
                <div class="news-date">2025</div>
                <h3 class="news-title">Enhanced Evaluation Workflow</h3>
                <p class="news-excerpt">
                    Auto-scoring, role-based access, and configurable evaluation criteria
                    have been added for better compliance and transparency.
                </p>
            </div>
            <div class="news-card reveal">
                <div class="news-date">2025</div>
                <h3 class="news-title">Integrated Dashboards</h3>
                <p class="news-excerpt">
                    Live operational dashboards with exportable reports are now available
                    for improved monitoring and decision-making.
                </p>
            </div>
        </div>
    </div>
</section> -->


<!-- Terminal Footer -->
<!-- <footer class="footer" id="contact">
    <div class="footer-content">
        <h2 class="footer-title">Innovation & Indigenisation Management Application (IIMA)</h2>
        <p class="footer-text ">
            The official digital platform of the Indian Navy for managing innovation
            and indigenisation initiatives. Designed to deliver transparency, speed,
            and efficiency for all stakeholders.
        </p>
        <p class="footer-copyright">
            © 2025 Indian Navy. All Rights Reserved. | Innovate • Indigenise • Excel
        </p>
    </div>
</footer> -->